import { useState } from 'react';
import EventReportFeed from './EventReportFeed';
import EventReportSheet from './EventReportSheet';

/** Self-contained event-report feed + slide-over, registered as an operation component. */
export default function EventReportOperation({ soulId }: { soulId: string }) {
  const [openReportId, setOpenReportId] = useState<string | null>(null);
  return (
    <>
      <EventReportFeed soulId={soulId} onOpenReport={setOpenReportId} />
      <EventReportSheet
        reportId={openReportId}
        open={!!openReportId}
        onOpenChange={(o) => !o && setOpenReportId(null)}
      />
    </>
  );
}
